<template>
  <b-card title="Action Log">
    <b-card-text>This is the Action Log page. The feature is under construction.</b-card-text>
  </b-card>
</template>

<script>
import { BCard, BCardText } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
  },
}
</script>
